const workdata = [
    {
        imageLink: "/works/company.png",
        alt: "ODDS-LLC",
        role: "Software Engineer",
        company: "ODDS LLC",
        time: "09/2025 - 02/2026",
        location: "Fort Worth, Texas",
        description: [
            "Developed and launched a user-centric sports analytics platform using Quasar and Pinia for state management, delivering player and match listings that boosted user engagement by 30% through interactive performance visualization.",
            "Engineered and maintained scalable RESTful back-end services using Node.js, Express, and MySQL, supporting 9,000+ player records and 1,000+ match datasets with reliable data integrity and seamless integration with a Quasar (Vue) front end.", 
            "Optimized performance-first backend APIs, implementing server-side pagination, optimized MySQL queries, and controlled payload sizing to reduce load times, prevent over-fetching, and ensure consistent low-latency responses at scale.",
            "Architected and built an internal admin dashboard to monitor user activity, manage player/game datasets, enforce role-based access, configure scheduling, drafts, and send announcement emails, to centralize operational workflows for the platform.",
        ], 
        skills: [
            "JavaScript", "Quasar", "Pinia", "Vue.js", "Express.js", "Node.js", "Docker", "GitHub Actions", "PostgreSQL"
        ]
    }, 
    {
        imageLink: "/works/unthsc.png",
        alt: "UNT-HSC",
        role: "FullStack Software Engineer",
        company: "UNT Health Science Center",
        time: "08/2024 - 05/2025",
        location: "Fort Worth, Texas",
        description: [
            "Developed a health-tracking application in a team of 6, managing 1000+ user records using React Native and SpringBoot.",
            "Implemented API integration, improving 30% of data flow between front-end and back-end.", 
            "Designed scalable, high-performance database by implementing the storage layer using PostgreSQL to store structured metadata and MongoDB to store flexible health data, standardizing constraints, and unifying related fields to ensure efficient querying and improve data integrity across multiple tables.",
            "Led a team of 5 teammates in an Agile workflow, allocating tasks, tracking progress, and ensuring the on-time delivery of project milestones with 100% adherence to deadlines.",
            "Utilized GitHub Actions to automate CI/CD pipelines, streamlining auto-deployment processes for Dockerized applications on the Render deployment platform."
        ], 
        skills: [
            "JavaScript", "Java", "React Native", "SpringBoot", "REST API", "PostgreSQL", "MongoDB", "GitHub Actions", "Agile", "Render", "Docker"
        ]
    }, 
    {
        imageLink: "/works/codepath.jpg",
        alt: "CodePath",
        role: "Student FullStack Developer",
        company: "CodePath",
        time: "09/2024 - 11/2024",
        location: "Fort Worth, Texas (Remote)",
        description: [
            "Completed the CodePath courses: WEB 103: Advanced Web Development; TIP 103: Advanced Technical Interview Prep.", 
            "Building three full-stack projects and a final capstone focused on appointment management.",
            "Collaborated with 2 other students in final capstone project to build BOOKEZ - a capstone project for managing appointments for salons.",
            "Gained hands-on experience in designing and implementing robust full-stack applications using the PERN stack and Railway.",
            "Strengthened skills in building efficient APIs, database management, and front-end user experiences.",
            "Developed expertise in deploying and optimizing full-stack solutions to handle real-world use cases."
        ],
        skills: [
            "React.js", "JavaScript", "PostgreSQL", "Git/Github", "MongoDB", "Node.js", "Express.js"
        ]
    }, 
    {
        imageLink: "/works/headstarterai.jpg",
        alt: "Headstarter AI",
        role: "Software Engineering Fellowship",
        company: "Headstarter AI",
        time: "07/2024 - 08/2024",
        location: "Fort Worth, Texas (Remote)",
        description: [
            "Built and deployed five AI-powered web applications at Headstarter AI, showcasing expertise in integrating machine learning models into scalable web solutions.", 
            "Designed user-friendly interfaces and seamless experiences by leveraging modern frameworks and libraries.",
            "Collaborated with cross-functional teams to optimize AI models for real-time performance and accuracy.",
            "Implemented robust APIs and database architectures to support AI-driven functionalities across applications."
        ],
        skills: [
            "React.js", "JavaScript", "Git/Github", "MongoDB", "Node.js", "Express.js"
        ]
    }, 
    {
        imageLink: "/works/ThankUPet.jpeg",
        alt: "ThankUPet",
        role: "FullStack Developer Internship",
        company: "ThankUPet",
        time: "05/2024 - 08/2024",
        location: "Fort Worth, Texas (Remote)",
        description: [
            "Engineered a scalable CRM platform for 100+ pets and owners, and used Next.js with Figma designs, resulting in a 40% increase in user engagement and streamlined pet management.", 
            "Generated thorough documentation for 21 APIs supporting a robust back-end solution in the pet-caring management system, resulting in increased user engagement and improved operational efficiency for the scheduling process.",
            "Applied Express and Node.js to implement efficient routing and middleware handling solutions, ensuring seamless API integration and responsiveness, and enhancing performance and reliability."
        ],
        skills: [
            "Next.js", "TypeScript", "PlanetScale", "Supabase", "Node.js", "Express.js"
        ]
    }, 
    {
        imageLink: "/works/texaschristianuniversity.png",
        alt: "TCU",
        role: "Mathematics Teaching Assistant",
        company: "Department of Mathematics",
        time: "01/2024 - 05/2025",
        location: "Fort Worth, Texas",
        description: [
            "Manage and improve homework performance of about 30 students in Mathematics classes.",
            "Developed detailed study guides for math and computer science courses and aided a robust understanding of key concepts.", 
            "Classess graded: MATH 20123: Discrete Mathematics I, MATH 30123: Discrete Mathematics II  (Dr. Herzig)."
        ], 
        skills: [
            "Mathematics"
        ]
    }, 
    {
        imageLink: "/works/texaschristianuniversity.png",
        alt: "TCU",
        role: "Computer Science Teacher Assistant",
        company: "Department of Computer Science",
        time: "08/2023 - 05/2025",
        location: "Fort Worth, Texas",
        description: [
            "Assist over 50 students with lab projects in Computer Science courses: Data Structures, Techniques in Programming, Python for Data Analytics, and Introduction to Programming.",
            "Improve students' programming proficiency and exam performance by 35% through tailored teaching methods customized for each student's learning style and skill level.",
            "Host weekly 4-hour Computer Science Help Desk session."
        ], 
        skills: [
            "Java, Java Swing", "Data Structure && Algorithms",
        ]
    },
    {
        imageLink: "/works/texaschristianuniversity.png",
        alt: "TCU",
        role: "Math Clinic Tutor",
        company: "Department of Mathematics",
        time: "08/2023 - 01/2024",
        location: "Fort Worth, Texas",
        description: [
            "Hosted weekly tutoring sessions for students, who take Mathematics classes in a semester.",
            "Developed detailed study guides for math and computer science courses and aided robust understanding of key concepts."
        ], 
        skills: [
            "Mathematics"
        ]
    }, 
    {
        imageLink: "/works/FPT.jpeg",
        alt: "FPT Software",
        role: "Software Engineer Internship",
        company: "FPT Software",
        time: "06/2023 - 08/2023",
        location: "Hai Phong, Vietnam",
        description: [
            "Build a CRM website with Angular for over 100,000 users to manage the rental housing and apartment industry.",
            "Implementing properties of RxJS and Ngrx to reduce 30% of the rendering time of the housing lists and components. ",
            "Leverage existing Django and Python APIs to build features that include managing email/text, setting appointments, and tracking messages, calls, and emails.",
            "Employ Bootstrap to render a design component provided in Figma, elevating the visual appeal of the application.",
            "Collaborate with 25+ members development team, with Agile to plan, track tasks, develop, and test the application."
        ],
        skills: [
            "SCSS", "RxJS", "Agile Methodologies", "TypeScript", "Responsive Web Design", "HTML", "CSS", "Django", "NgRx", "Bootstrap", "Angular"
        ]
    }, 
    {
        imageLink: "/works/texaschristianuniversity.png",
        alt: "TCU",
        role: "Information Common Desk Assistant",
        company: "Mary Couts Burnett Library",
        time: "09/2022 - 05/2025",
        location: "Fort Worth, Texas",
        description: [
            "Deals with the students' demands of studying devices."
        ]
    }, 
]

export default workdata;